import { FC, ReactElement } from 'react'

import { ListGroupItem } from '@/components'
import { convertDateToDateYearString } from '@/helpers/DateTimeParser'
import { trans } from '@/helpers/trans'
import { UserDocumentViewModel } from '@/models'
import { downloadUserDocument } from '@/services/UserDocumentService/downloadUserDocument'

import './DocumentListItem.scss'

interface DocumentListItemProps {
    document: UserDocumentViewModel
    onClick?: () => void
    className?: string
}

export const DocumentListItem: FC<DocumentListItemProps> = ({ document, onClick = () => {}, className = '' }): ReactElement => (
    <ListGroupItem
        onClick={onClick}
        className={className}
    >
        <button onClick={() => downloadUserDocument(document)} type="button" className="document-list-item list-group-item__header text w-100">
            <div className="d-flex">
                <div className="font-weight-bold">{document.displayName}</div>
            </div>
            <div className="d-flex justify-content-between w-100">
                <div className="pr-1">
                    {trans(`pages.documents.${document.documentType?.slug}`)}
                </div>
                <div className="text-right">
                    {document.createdAt
                        ? convertDateToDateYearString(document.createdAt) : null}
                </div>
            </div>
        </button>
    </ListGroupItem>
)
